export default __webpack_public_path__ + "assets/howWork4.8a11d421.png";